import React, {useCallback, useContext} from 'react';

import {RemoveButton} from 'src/components/remove-button';

import {Integer} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import {LocaleContext} from '@pb/kit-context-locale';

import {apiV2AlertsTableCell, apiV2AlertsTableRow} from '../views/alerts.view.module.styl';

type Props = {
    contractNumber: string,
    contractId: number,
    credit: number,
    onRemove: (contractId: number, credit: number) => void,
    showCaption: boolean,
    disabled?: boolean,
};
export const CreditItem = (props: Props) => {
    const {locale} = useContext(LocaleContext);
    const {onRemove, contractNumber, contractId, credit, showCaption, disabled} = props;
    const onRemoveCallback = useCallback(() => {
        onRemove(contractId, credit);
    }, [contractId, credit, onRemove]);

    return (
        <div className={apiV2AlertsTableRow}>
            <div className={apiV2AlertsTableCell}>{showCaption ? contractNumber : ''}</div>
            <div className={apiV2AlertsTableCell}>
                <Group justify="space-between" alignItems="center">
                    <span>{Integer.format(credit, locale)}</span>
                    <RemoveButton {...{onRemove: onRemoveCallback, disabled}}/>
                </Group>
            </div>
        </div>
    );
};
